<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <div v-click-outside="hideSearch" :class="{ 'overall-search': true, 'overall-search-should-closed': shouldHideOnSmallScreens }">
    <v-text-field
      v-if="!searchFields.length"
      v-model.trim="searchValue"
      variant="outlined"
      density="compact"
      clearable
      clear-icon="mdi-close"
      hide-details
      :placeholder="$lang.labels.search"
      prepend-inner-icon="mdi-magnify"
      class="expanding-search"
      data-cy="global-search"
      :loading="loading"
      :class="{ closed: searchBoxClosed && !searchValue }"
      @keyup.enter="search"
      @focus="searchBoxClosed = false; show = !!result.length"
      @blur="searchBoxClosed = true"
      @click:clear="result = []; show = false"
    />
    <v-text-field
      v-else
      v-model.trim="searchValue"
      variant="outlined"
      density="comfortable"
      clearable
      clear-icon="close"
      hide-details
      :placeholder="placeholder ? $lang.labels[placeholder] : $lang.labels.addTemplate"
      prepend-inner-icon="mdi-magnify"
      class="expanding-search"
      data-cy="global-search"
      :loading="loading"
      @keyup.enter="searchSpecificFields"
      @focus="show = !!result.length"
      @click:clear="result = []; show = false"
    />
    <v-expand-transition v-if="show && (!searchFields?.length || searchFields.length === 1)">
      <v-list class="search-result">
        <v-list-item
          v-for="(item, i) in result"
          :key="i"
          class="result-item"
          :to="'/' + $route.params.lang + item.route + item.id"
          link
          @click="show = false"
        >
          <v-list-item-title class="d-flex align-center">
            <v-icon size="x-small">
              {{ item.icon }}
            </v-icon>
            <div class="ms-1">
              {{ item.name }}
            </div>
          </v-list-item-title>
          <v-list-item-subtitle v-text="item.comment" />
        </v-list-item>
        <v-list-item v-if="(searchValue && searchValue.length >= 3 && !result.length) || !timer">
          <div class="no-search-result">
            No search result
          </div>
        </v-list-item>
      </v-list>
    </v-expand-transition>
    <v-expand-transition v-if="show && searchFields?.length && searchFields.length > 1">
      <v-list class="search-result">
        <v-list-item

          v-for="(item, i) in result"
          :key="i"
          class="result-item"
          @click="add(item.name, item.type); searchValue = null"
        >
          <v-list-item-title class="d-flex align-center">
            <v-icon size="small">
              {{ item.icon }}
            </v-icon>
            <div class="ms-1">
              {{ item.name }}
            </div>
          </v-list-item-title>
          <v-list-item-subtitle v-text="item.comment" />
        </v-list-item>
        <v-list-item v-if="isSearchValueLongEnoughAndNoResult || !isTimerActive">
          <div class="no-search-result">
            No search result
          </div>
        </v-list-item>
      </v-list>
    </v-expand-transition>
  </div>
</template>

<script>
import {
  getTriggerCronsUsingGET as getCrons,
  getTriggerMessagingsUsingGET as getMessagings,
  getTriggerRestsUsingGET as getRests,
  getTriggerMcpsUsingGET as getMcps,
  getTriggerUisUsingGET as getUiTriggers,
  getTriggerWhatsAppsUsingGET as getWhatsapps,
  getProcessesUsingGET as getProcesses,
  getProcessCredentialsUsingGET as getCredentials,
  getTextTemplatesUsingGET as getTemplates,
  getTranslationsUsingGET as getTranslations,
  getValidationRulesUsingGET as getValidations,
  getPluginsUsingGET as getPlugins,
  getModulesUsingGET as getModules,
  getUsersUsingGET as getUsers,
  getRolesUsingGET as getRoles,
  getLibrariesUsingGET as getLibraries,
  getStoragesUsingGET as getStorage,
  getProcessByIdUsingGET as getProcess,
  getTriggerEventHandlersUsingGET as getEventHandlers,
  getEntitiesUsingGET as getEntities,
  getStaticResourcesUsingGET as getStaticResources,
  getAiAgentsUsingGET as getAiAgents,
  getScreensUsingGET as getScreens,
  getFlowsUsingGET as getFlows,
  getApplicationsUsingGET as getApplications
} from '@/utils/api'
import { getFlowyObjectIcon } from '@/utils/flowyObjectIcons'

export default {
  props: {
    searchFields: {
      type: Array,
      default: () => []
    },
    shouldHideOnSmallScreens: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false,
      searchValue: '',
      searchBoxClosed: true,
      loading: false,
      timer: null,
      result: [],
      getFunctionsForOneField: {
        getTemplates,
        getStaticResources
      }
    }
  },
  computed: {
    isSearchValueLongEnoughAndNoResult() {
      return this.searchValue && this.searchValue.length >= 3 && !this.result.length
    },
    isTimerActive() {
      return this.timer !== null
    }
  },
  watch: {
    searchValue: {
      handler() {
        if (!this.searchValue) {
          this.show = false
          this.result = []
        }
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (this.searchFields?.length) {
            this.searchSpecificFields()
          } else {
            this.search()
          }
        }, 750)
      }
    }
  },
  methods: {
    add(name, type) {
      this.$emit('addTemplate', {name, type} )
      this.show = false
    },
    async searchSpecificFields() {
      this.result = []
      this.show = false
      this.loading = false
      if (!this.searchValue || this.searchValue.length < 3) {
        return
      }
      this.loading = true

      if (!this.searchFields?.length) return

      for (const searchField of this.searchFields) {
        const getFunction = this.getFunctionsForOneField[searchField]

        if (!getFunction) return

        try {
          const res = await getFunction({ name: this.searchValue })

          const results = res.data.data.items
            .filter(i => +i.id !== +this.$route.params.id)
            .map((i) => {
              const options = getFlowyObjectIcon(res.config.url)

              if (options) {
                i.icon = options.icon
                i.route = options.url
              }
              i.type = searchField

              return i
            })

          this.result.push(...results)
        } catch (error) {
          console.log('error', error)
        } finally {
          this.show = true
          this.loading = false
        }
      }
    },
    search() {
      this.result = []
      this.show = false
      this.loading = false
      if (!this.searchValue || this.searchValue.length < 3) {
        return
      }
      this.loading = true
      const crons =  getCrons({ name: this.searchValue })
      const messagings = getMessagings({ name: this.searchValue })
      const rests = getRests({ name: this.searchValue })
      const mcps = getMcps({ name: this.searchValue })
      const uiTriggers = getUiTriggers({ name: this.searchValue })
      const processes = getProcesses({ name: this.searchValue })
      const credentials = getCredentials({ name: this.searchValue })
      const templates = getTemplates({ name: this.searchValue })
      const translations = getTranslations({ name: this.searchValue })
      const validations = getValidations({ name: this.searchValue })
      const plugins = getPlugins({ name: this.searchValue })
      const modules = getModules({ name: this.searchValue })
      const users = getUsers({ name: this.searchValue })
      const roles = getRoles({ name: this.searchValue })
      const libraries = getLibraries({ name: this.searchValue })
      const storageKeys = getStorage({ key: this.searchValue })
      const eventHandlers = getEventHandlers({ name: this.searchValue })
      const entities = getEntities({ name: this.searchValue })
      const staticResources = getStaticResources({ name: this.searchValue })
      const screens = getScreens({ name: this.searchValue })
      const aiAgents = getAiAgents({ name: this.searchValue })
      const flows = getFlows({ name: this.searchValue })
      const whatsapps = getWhatsapps({ name: this.searchValue })
      const applications = getApplications({ name: this.searchValue })

      Promise.all([
        crons,
        messagings,
        rests,
        mcps,
        uiTriggers,
        processes,
        credentials,
        templates,
        translations,
        validations,
        plugins,
        modules,
        users,
        roles,
        libraries,
        storageKeys,
        eventHandlers,
        entities,
        staticResources,
        aiAgents,
        screens,
        flows,
        whatsapps,
        applications
      ]).then((data) => {
        data.map(async (item) => {
          const resultMap = item.data.data.items.map(async (i) => {
            const options = getFlowyObjectIcon(item.config.url)

            if (options) {
              i.icon = options.icon
              i.route = options.url
            }

            // Handle storage items specially (fetch process name)
            if (item.config.url.includes('storage') && i.processId) {
              try {
                const process = await this.fetchProcess(i.processId)
                if (process?.name) {
                  i.name = i.key + ' (' + process.name + ')'
                }
              } catch {
                // Process fetch failed, continue without processName
              }
            }

            return i
          })

          await Promise.all(resultMap)
            .then((result) => {
              this.result.push(...result)

              return result
            })
            .catch((error) => {
              console.log(error)
            })
        })
      }).catch((error) => {
        console.log('error', error)
      }).finally(() => {
        this.show = true
        this.loading = false
      })
    },
    hideSearch() {
      this.show = false
      this.searchBoxClosed = true
    },
    async fetchProcess(id) {
      return new Promise((resolve, reject) => {
        getProcess({ id })
          .then((res) => {
            resolve(res.data.data)
          })
          .catch(() => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(false)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .overall-search {
    display: flex;
    width: 100%;

    .result-item {
      cursor: pointer;
    }

    .search-result {
      max-height: 350px;
      position: absolute;
      overflow-x: hidden;
      overflow-y: auto;
      border: 2px solid rgb(var(--v-theme-primary));
      border-radius: 5px;
      z-index: 1;
      right: 200px;
      top: 50px;
    }

    .no-search-result {
      display: flex;
      justify-content: center;
    }

    .expanding-search {
      transition: max-width 0.5s;
      margin-left: auto;
      margin-right: 0 !important;
      width: 300px;
      max-width: 300px;

      &.closed {
        max-width: 48px;
      }

      ::v-deep(.v-field--active .v-icon) {
        color: rgb(var(--v-theme-primary)) !important;
        caret-color: rgb(var(--v-theme-primary)) !important;
      }
    }
  }


  @media screen and (max-width: 890px) {
    .overall-search-should-closed {
      display: none !important;
    }
  }
</style>
